import React, { useState, useEffect, useRef } from "react"; 
import { auth } from '../FirebaseComp/firebase';
import { Link, useNavigate } from 'react-router-dom'; 
import "./nav.css";
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min.js'; // Added this line
import '@fortawesome/fontawesome-free/css/all.min.css'; // Font Awesome CSS


import { FaUserCircle, FaCaretDown, FaBars, FaTimes } from 'react-icons/fa'; 
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'; 
import { faUser, faFile, faSignOutAlt, faBook, faTablet } from '@fortawesome/free-solid-svg-icons'; 


export const NavComp = () => {
  const navRef = useRef(null);
  const [scrolled, setScrolled] = useState(false);






  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [showDropdown, setShowDropdown] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const dropdownRef = useRef(null);
  const navigate = useNavigate();

  useEffect(() => {
    const unsubscribe = auth.onAuthStateChanged((user) => {
      setIsLoggedIn(!!user);
    });
    return () => unsubscribe();
  }, []);

  const handleLogout = async () => {
    try {
      await auth.signOut();
      setIsLoggedIn(false);
      navigate('/');
    } catch (error) {
      console.error('Error logging out:', error);
    }
  };

  const toggleDropdown = () => {
    setShowDropdown(!showDropdown);
  };

  const handleDropdownClick = (event) => {
    if (dropdownRef.current && dropdownRef.current.contains(event.target)) {
      setShowDropdown(false);
    }
  };


























  // Close navbar on mobile
  const closeNavbar = () => {
    if (navRef.current?.classList.contains("show")) {
      navRef.current.classList.remove("show");
    }
  };

  // Track scroll for sticky transparent effect
  React.useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <nav 
        className={`navbar navbar-expand-lg navbar-dark sticky-top ${scrolled ? "scrolled" : ""}`}
        style={{ backgroundColor: scrolled ? "rgba(17, 24, 39, 0.95)" : "rgb(17, 24, 39)" }}
      >

      <div className="container-fluid">
      <Link className="navbar-brand" to="/" style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
        <img
          src="/logo192.jpg"
          alt="Ceylon Eye Care Optometric Association"
          height="50"
          className="logo-round"
          style={{ marginRight: '12px' }} // Alternative spacing method
        />
        <span style={{ marginLeft: '12px' }}>CECOA</span>
      </Link>

        {/* Mobile Toggle Button */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarNav"
          aria-controls="navbarNav"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        {/* Navbar Links */}
        <div className="collapse navbar-collapse" id="navbarNav" ref={navRef}>
          <ul className="navbar-nav ms-auto">
            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeNavbar}>Home</Link>
            </li>

            <li className="nav-item dropdown">
            <Link to="/advocacy" className="nav-link" onClick={closeNavbar}>Advocacy</Link>
            </li>




            {/* Social Impact Dropdown */}
            <li className="nav-item dropdown">
              <Link 
                className="nav-link dropdown-toggle" 
                to="#" 
                id="socialImpactDropdown" 
                role="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                About
              </Link>
              <ul className="dropdown-menu" aria-labelledby="socialImpactDropdown">
                <li><Link to="/aboutus" className="dropdown-item" onClick={closeNavbar}>About Us</Link></li>
                <li><Link to="/leadership" className="dropdown-item" onClick={closeNavbar}>CEOA Leadersahip</Link></li>
                <li><Link to="/contactus" className="dropdown-item" onClick={closeNavbar}>Contact Us</Link></li>
          
              </ul>
            </li>


            <li className="nav-item">
              <Link to="/payment-portal" className="nav-link" onClick={closeNavbar}>Payment Portal</Link>
            </li>



            {/* Social Impact Dropdown */}
            {/* <li className="nav-item dropdown">
              <Link 
                className="nav-link dropdown-toggle" 
                to="#" 
                id="socialImpactDropdown" 
                role="button" 
                data-bs-toggle="dropdown" 
                aria-expanded="false"
              >
                Sample
              </Link>
              <ul className="dropdown-menu" aria-labelledby="socialImpactDropdown">
                <li><Link to="#" className="dropdown-item" onClick={closeNavbar}>sample 1</Link></li>
                <li><Link to="#" className="dropdown-item" onClick={closeNavbar}>sample 2</Link></li>
              </ul>
            </li> */}

            <li className="nav-item">
              <Link to="/" className="nav-link" onClick={closeNavbar}>Find An Optometrist</Link>
            </li>

            <li className="nav-item">
              <Link to="/eventandnews" className="nav-link" onClick={closeNavbar}>Event & News</Link>
            </li>

           
           {/* Add Sign In and Sign Up buttons inside the toggle menu */}
        {!isLoggedIn && (
          <li className="auth-buttons">
            <Link to="/signin">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN IN</button>
            </Link>
            <Link to="/signup">
              <button className="navbar-btn-login" onClick={closeNavbar}>SIGN UP</button>
            </Link>
          </li>
        )}

          </ul>




      <div className="navbar-buttons">
        {isLoggedIn ? (
          <>
    
            <div className="user-menu-container">
              <button className="user-icon" onClick={toggleDropdown}>
                <FaUserCircle size={24} /> <FaCaretDown size={16} />
              </button>
              {showDropdown && (
                <ul className="user-dropdown" ref={dropdownRef}>
                  <li>
                    <Link to="/userprofile" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faUser} className="me-2" /> My Profile
                    </Link>
                  </li>
                  <li>
                    <Link to="/viewapplication" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> View My All Payments 
                    </Link>
                  </li>

                  <li>
                    <Link to="/viewpayment" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faFile} className="me-2" /> Download My Payment Slips
                    </Link>
                  </li>

                  <li>
                    <Link to="/followup-resources" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faBook} className="me-2" /> Follow-up Resources
                    </Link>
                  </li>

                  <li>
                    <Link to="/knowledge-quest" onClick={handleDropdownClick}>
                      <FontAwesomeIcon icon={faBook} className="me-2" /> Knowledge Quest
                    </Link>
                  </li>


                  <li>
                    <button onClick={(e) => { handleLogout(); handleDropdownClick(e); }}>
                      <FontAwesomeIcon icon={faSignOutAlt} className="me-2" /> Log Out
                    </button>
                  </li>
                </ul>
              )}
            </div>
          </>
        ) : (
          <></>
        )}
      </div>













        </div>
      </div>
    </nav>
  );
};